import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { BsModalRef } from "ngx-bootstrap/modal";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { PartyService, SalesInvoiceService, SalesOrderService } from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./addPayment.html",
})
export class addPayment {
  @Output() paymentUpdateEvent = new EventEmitter();
  row: any;
  data: any;
  qualityList: any;
  typeList: any;
  lineLists: any;
  party_type: any;
  colorList: any;
  codeList: any;
  partyList = [];
  partyDetails = [];
  partydata: any = {
    cour_id: 0,
    cour_no: "",
    cour_date: "",
    cour_name: ""
  };
  teamList = ["CHEQUE", "DD"];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  mode: string;
  saveEvent: any;
  agentList: any;
  purchaseAgentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  statusList = [{ name: "ACTIVE" }, { name: "INACTIVE" }];
  boxlessList = [{ name: "YES" }, { name: "NO" }];

  @Input() set paymentdata(val: any[]) {

    this.mode = val["mode"];
    if (this.mode == 'Add') {
      this.partydata = Object.assign({}, val["cour_data"]);
      this.partydata.cour_id = val["cour_id"];
      this.getAgentList();
      this.getSalesParty();
  
    }
    else if (this.mode == "View") {
      this.loaddesignList(val["cour_id"]);
      this.partydata = Object.assign({}, val);
       this.partydata.party_name = val["party_code"]
   
    }
  }

  @ViewChild("agentAuto") agentAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  statusCtrl: FormControl = new FormControl();
  lineCtrl: FormControl = new FormControl();
  inchargeCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  mobilenoCtrl: FormControl = new FormControl();
  boxlessCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private partyService: PartyService,
    private salesinvservice: SalesInvoiceService,
    private salesservice: SalesOrderService
  ) { }
  ngOnInit() {
    // this.partyDetails.length = 25
    if (this.mode == "Add") {
      this.partydata.join_date = this.datePipe.transform(
        new Date(),
        "yyyy-mm-dd"
      );
      this.partydata.inactive_date = this.datePipe.transform(
        new Date(),
        "yyyy-mm-dd"
      );
      //  this.partydata.status = 'ACTIVE';
      this.getAgentList();
      this.getSalesParty();
      // console.log("function Check")

    }

   

  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#code").focus();
    }, 100);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "partySave") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      // this.save();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      type: 'paymentVoucher'
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  addPaymentDet(data) {
    let temp_date = data.chq_date
    temp_date = this.datePipe.transform(
      temp_date,
      "dd-MM-yyyy"
    );
    data.chq_date = this.datePipe.transform(
      data.chq_date,
      "yyyy-MM-dd"
    );
    let rowdata = {
      chq_date: temp_date,
      payment_type: data.payment_type,
      chq_no: data.chq_no,
      chqdate_format: data.chq_date,
      bank_name: data.bank_name,
      amount: data.amount
    }
    let rowdetail = Object.assign({}, rowdata);
    this.partyDetails.push({ ...rowdetail });
    data.chq_date = "";
    data.chq_no = "";
    data.bank_name = "",
      data.amount = 0
  }

  onSelectPartyName(party_code) {
    let partylist = _.filter(this.partyList, { party_code: party_code });
    if (partylist.length > 0) {
      this.partydata.agent_id = partylist[0]["agent_id"];
      this.partydata.party_id = partylist[0]["genLedid"];
      // this.partydata.disper = partylist[0]["discount"];

      let fitem = _.find(this.agentList, {
        genLedid: this.partydata.agent_id,
      });
      this.partydata.agent_name = fitem["name"];
      this.partydata.team = partylist[0]["incharger"];
    }

    $("#team").focus();
  }
  getAgentList() {
    let that = this;
    that.partyService.getAgentList({}).then((res: any) => {
      that.agentList = res;
      that.agentCtrl.setValue(that.partydata["agent_name"]);
      if (that.mode == "Edit" || that.mode == "View") {
        let partylist = _.filter(that.agentList, {
          genLedid: that.partydata.agent_id,
        });
        that.partydata.agent_name = partylist[0]["name"];
      }
    });
  }
  loaddesignList(id){
    let params = {
      cour_id: id,
    };
    this.salesservice.geViewInwardPDCist(params).then((res: any) => {
      this.partyDetails = res.data;
    
    });
  }
  getPurchaseAgentList() {
    let that = this;
    that.partyService.getPurchaseAgentList({}).then((res: any) => {
      that.purchaseAgentList = res;
    });
  }
  getTotdisc() {

    this.partydata.discount = Number(this.partydata.act_discount) + Number(this.partydata.special_discount)
  }
  onDeleteRow(ind) {
    this.partyDetails.splice(ind, 1)
  }
  saveCourierPayment() {

    //  for (x in this.partydata){

    //  }
    // ) {
    //   swal("Enter all the required fields");
    // }

    let that = this;
    let params: any = Object.assign({}, this.partydata);
    params["mode"] = this.mode
    params["date"] = this.datePipe.transform(
      this.partydata.chq_date,
      "yyyy-MM-dd"
    );

    params["data"] = JSON.stringify(this.partyDetails)
    swal({
      title: "Are you sure to save this Details?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoading = true;
      that.salesservice
        .saveCourierPayment(params)
        .then(function (res: any) {
          if (res.success) {
            // that.partydata = {

            // };

            that.bsModalRef.hide();
            that.paymentUpdateEvent.emit();
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    });

  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Agent") {
      list = this.agentList;
    }
    if (this.agentList.length > 0) {
      if (id && list.length > 0) {
        let fitem = _.find(list, { name: id });
        this.partydata.agent_name = fitem["name"];
        this.partydata.agent_id = fitem["genLedid"];
        return fitem["name"];
      }
    }

    return "";
  }
  onSelectAgentName(agent_name) {
    let fitem = _.find(this.agentList, { name: agent_name });
    this.partydata.agent_name = fitem["name"];
    this.partydata.agent_id = fitem["genLedid"];
  }

  onSelectPurchaseAgentName(agent_name) {
    let fitem = _.find(this.purchaseAgentList, { agent_name: agent_name });
    this.partydata.purchase_agent = fitem["agent_name"];
    this.partydata.purchase_agent_id = fitem["agent_id"];
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/courier/addPayment.ts